import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  Renderer2
} from '@angular/core';
import {
  first,
  from,
  Observable
} from 'rxjs';

@Directive({
  selector: '[appProgressClick]',
  standalone: true
})
export class ProgressClickDirective {
  appProgressClick = input.required<() => Observable<unknown> | Promise<unknown>>();
  private el: ElementRef<HTMLButtonElement> = inject(ElementRef);
  private renderer = inject(Renderer2);
  private readonly spinner: HTMLDivElement;

  constructor() {
    const spinner = this.renderer.createElement('span') as HTMLDivElement;
    this.renderer.setStyle(spinner, 'float', 'left');
    spinner.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" class="animate-spin h-5 w-5 text-white ng-star-inserted"
    fill="none" viewbox="0 0 24 24">
<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014
 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
</svg>`;
    this.spinner = spinner;
  }

  @HostListener('click') clickEvent(): void {
    this.renderer.setAttribute(this.el.nativeElement, 'disabled', '');
    const firstChild = this.el.nativeElement.querySelector('img');
    if (firstChild) {
      this.renderer.removeChild(this.el.nativeElement, firstChild);
    }
    this.renderer.insertBefore(this.el.nativeElement, this.spinner, this.el.nativeElement.firstChild);
    from(this.appProgressClick()())
      .pipe(first())
      .subscribe({
        complete: () => {
          this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
          this.renderer.removeChild(this.el.nativeElement, this.spinner);
          if (firstChild) {
            this.el.nativeElement.prepend(firstChild);
          }
        },
        error: () => {
          this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
          this.renderer.removeChild(this.el.nativeElement, this.spinner);
          if (firstChild) {
            this.el.nativeElement.prepend(firstChild);
          }
        },
      });
  }
}
